<template>
  <div>
    <div class="w-20 border-t-4 border-n3yellow my-10"></div>
    <div class="page-heading">Sorry you are looking not found.</div>

    <div class="space-y-8 page-content mb-[6rem]">
      <p class="mt-[2rem]"></p>
      <div class="pt-10">
        <default-button
          class="w-full sm:w-2/6"
          label="Back to home"
          @click="$router.push({ name: 'home' })"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";
import { scrollToTop } from "@/utils/helper";
import { useMeta } from "vue-meta";
import DefaultButton from "@/components/button/DefaultButton.vue";
export default {
  components: { DefaultButton },
  name: "404Page",
  setup() {
    useMeta({
      title: "Page not found",
    });
    onMounted(() => {
      scrollToTop();
    });
  },
};
</script>
